// components/CustomerPrivateRoute.jsx
import { Navigate, useLocation } from 'react-router-dom'
import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'

// A page that needs a signed-in customer. The session (token) decides, not a
// cached user object: a user without a token is not signed in.
const CustomerPrivateRoute = ({ children }) => {
  const { user, token } = useContext(AuthContext)
  const location = useLocation()

  if (!user || !token) {
    return <Navigate to="/account-login" replace state={{ from: { pathname: location.pathname, search: location.search } }} />
  }

  return children
}

export default CustomerPrivateRoute
